'use client';

import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FaqAccordion, { FaqItem } from '../_shared/sections/FaqAccordion';

type Props = { lang: Locale };

type FaqKey = 'audit' | 'methods' | 'expiry' | 'plan' | 'docusign' | 'signup';

const FAQS: readonly FaqKey[] = ['audit', 'methods', 'expiry', 'plan', 'docusign', 'signup'] as const;

const ESignatureFAQ = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const items: FaqItem[] = FAQS.map((k) => ({
    key: k,
    q: t(`ESignature/FAQ/${k}_q`),
    a: t(`ESignature/FAQ/${k}_a`),
  }));

  return (
    <FaqAccordion
      lang={lang}
      num="04"
      label={t('ESignature/FAQ/badge')}
      headline={t('ESignature/FAQ/title')}
      items={items}
    />
  );
};

export default ESignatureFAQ;
